module.exports = __webpack_public_path__ + "img/11.e45a1ec0.jpg";